import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    regionalText: {
      ...CommonFonts.darkBoldFont30,
      fontSize: 34,
      letterSpacing: 0.28,
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
    },
    addDeliveryButton: {
      "&.MuiButton-root": {
        fontSize: 16,
        fontWeight: "bold",
        textTransform: "none",
      },
    },
    addCostButton: {
      "&.MuiButton-root": {
        fontSize: 16,
        fontWeight: "bold",
        lineHeight: 0,
      },
    },
    codeText: {
      ...CommonFonts.darkBoldFont22,
    },
    labelText: {
      ...CommonFonts.darkFont16,
    },
    timeText: {
      ...CommonFonts.darkFont20,
      color: Colors.DIM_GREY,
    },
  })
);

export default useStyles;
